<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ant">
<p class="center">Author’s Note</p>
<p class="nonindent">The events described in this book took place over thirteen years ago. In writing the book I relied solely upon my memory and the letters I wrote home to a few friends. I did not seek professional support from medical staff at University College Hospital. Any technical explanations (or technical errors) are mine.</p>
<p class="indent">The names of many of the people in this book have been changed to protect their privacy. Some characters are not based on any one person but are composite characters.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062032379_epub_ant_r1.vue?7f03d05d